module.exports = __webpack_public_path__ + "static/img/ic_date@3x.ddfc4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ic_date@3x.png
// module id = 7g7p
// module chunks = 10